import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-confirm-logout',
  templateUrl: './confirm-logout.component.html',
  styleUrls: ['./confirm-logout.component.scss'],
})
export class ConfirmLogoutComponent implements AfterViewInit {
  @Input() title = '';
  @Input() message = '';
  @Input() confirmBtnText = '';
  @Input() denyBtnText = '';
  @ViewChild('confirmModal') modal: ElementRef<HTMLElement> | unknown;

  @Output() modalID: EventEmitter<unknown> = new EventEmitter();
  @Output() logout: EventEmitter<unknown> = new EventEmitter();

  ngAfterViewInit(): void {
    this.modalID.emit(this.modal);
  }
}
